var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "frequency-modal-wrapper",
      class: { "frequency-modal-wrapper--active": _vm.saveScheduleResponse },
    },
    [
      _c("mds-loader", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.modalLoading && _vm.storedHolidays.length > 0,
            expression: "modalLoading && storedHolidays.length > 0",
          },
        ],
        staticClass: "loader",
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.modalLoading && !_vm.saveScheduleResponse,
              expression: "!modalLoading && !saveScheduleResponse",
            },
          ],
          staticClass: "frequency-modal-content",
        },
        [
          _c("frequency-modal-header"),
          _vm._v(" "),
          _c("frequency-modal-content", {
            attrs: {
              "without-job-name": _vm.withoutJobName,
              "frequency-form": _vm.frequencyForm,
            },
            on: {
              input: _vm.addInfoToForm,
              error: function ($event) {
                _vm.timeError = $event
              },
              validDate: function ($event) {
                _vm.validDate = !$event
              },
              validName: function ($event) {
                _vm.validName = $event
              },
              name: function ($event) {
                _vm.jobName = $event
              },
              selectedHolidays: function ($event) {
                _vm.selectedHolidays = $event
              },
            },
          }),
          _vm._v(" "),
          _c("complementary-fields-wrapper", {
            attrs: {
              "display-summary-time": _vm.disableSaveButton,
              "display-trigger-file": _vm.displayTriggerFile,
              "frequency-form": _vm.frequencyForm,
              "selected-holidays": _vm.selectedHolidays,
            },
            on: { triggerFile: _vm.addInfoToForm },
          }),
          _vm._v(" "),
          _c("frequency-modal-buttons", {
            attrs: { "disable-save-button": _vm.disableSaveButton },
            on: {
              "save-schedule": _vm.saveSchedule,
              close: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("scheduler-modal-save-response", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.saveScheduleResponse,
            expression: "saveScheduleResponse",
          },
        ],
        attrs: {
          type: "schedule",
          "has-duplicate-name": _vm.hasDuplicateName,
          "save-status": _vm.saveScheduleStatus,
        },
        on: {
          save: _vm.saveSchedule,
          close: _vm.closeModal,
          "change-name": _vm.renameSchedule,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }